<div class="modal-header justify-content-between">
  <div>
    <h4>Time Off Request</h4>
    <small class="ms-2">{{ existingModel.StartDate | date: 'MM/dd/YY' }}</small>
  </div>
  <div>
    <span class="badge bg-connectpay" *ngIf="!existingModel.Removed">Approved</span>
    <span class="badge bg-danger" *ngIf="existingModel.Removed">Declined</span>
    <button type="button" class="close ms-3" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body" *ngIf="existingModel != null">
  <div class="row">
    <div class="col-7">
      <div class="row mb-3">
        <div class="col-12">
          <span>Time Off Type: </span>
          <span>{{ existingModel.PlanName }}</span>
        </div>
      </div>
      <div class="row mb-3">
        <div class="d-flex justify-content-start">
          <span class="pe-3">Request Type: </span>
          <div class="d-flex flex-column justify-content-start">
            <div>
              <span *ngIf="existingModel.RequestType == RequestTypes.PartialDay">Partial Day</span>
              <span *ngIf="existingModel.RequestType == RequestTypes.SingleDay">Single Day</span>
              <span *ngIf="existingModel.RequestType == RequestTypes.MultipleDays"
                >Multiple Days</span
              >
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="existingModel.RequestType == RequestTypes.SingleDay">
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-start">
              <span class="pe-3">Date: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.StartDate | date: 'MM/dd/YY' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <span class="pe-3">Hours: </span>
            <span>{{ hours | async }}</span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="existingModel.RequestType == RequestTypes.PartialDay">
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-start">
              <span class="pe-3">Date: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.StartDate | date: 'MM/dd/YY' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-6">
            <div class="d-flex justify-content-between">
              <span>Start Time: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.StartDate | date: 'shortTime' }}</span>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex justify-content-between">
              <span>End Time: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.EndDate | date: 'shortTime' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-start">
              <span class="pe-3">Hours: </span>
              <div class="d-flex flex-column justify-content-start">
                <span *ngIf="existingModel.RequestType == RequestTypes.PartialDay">{{
                  hours | async | number: '1.2'
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="existingModel.RequestType == RequestTypes.MultipleDays">
        <div class="row mb-3">
          <div class="col-6">
            <div class="d-flex justify-content-between">
              <span>Start: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.StartDate | date: 'MM/dd/YY' }}</span>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="d-flex justify-content-between">
              <span>End: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.EndDate | date: 'MM/dd/YY' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex justify-content-start">
              <span class="pe-3">Hours Per Day: </span>
              <div class="d-flex flex-column justify-content-start">
                <span>{{ existingModel.TimeOffDays[0].Hours | number: '1.2' }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="col-5">
      <lib-hours-display [planId]="currentPlanObs" [personId]="personId"></lib-hours-display>
    </div>
  </div>
  <div class="row mt-1">
    <div class="col-12">
      <label>Employee Comments:</label><br />
      {{ existingModel.EmployeeComments }}
    </div>
  </div>
  <div class="row mt-1">
    <div class="col-12">
      <label>Employer Comments:</label><br />
      {{ existingModel.Comments }}
    </div>
  </div>
</div>
<div class="modal-footer text-right" *ngIf="existingModel != null && !existingModel.Removed">
  <button class="btn btn-secondary" *ngIf="!existingModel.HasPayroll" (click)="cancelRequest()">
    Cancel Request
  </button>
  <button class="btn btn-primary" (click)="closeModal()">Close</button>
</div>
